import { useState, useEffect, useRef } from 'react'
import { ethers } from "ethers"
//import Identicon from 'identicon.js';
import { Card, Button, ButtonGroup } from 'react-bootstrap'

const Home = ({ contract,account }) => {
  const audioRef = useRef(null);
  const [loading, setLoading] = useState(true)
  const [whitelisted, setWhitelisted] = useState(true)
  const [priceAll, setPriceAll] = useState(true)
  const [isPlaying, setIsPlaying] = useState(null)
  const [currentItemIndex, setCurrentItemIndex] = useState(0)
  const [marketItems, setMarketItems] = useState(null)

  const loadMarketplaceItems = async () => {
    // Get all unsold items/tokens
    const results = await contract.getAllUnsoldTokens()
  //  console.log("results: ",results);
    const priceTemp = await contract.price()
    setPriceAll(priceTemp)

    const  wl = await contract.isWhitelisted(account)
    console.log("isWhitelisted: ",wl);
    setWhitelisted(wl)


    const marketItems = await Promise.all(results.map(async i => {
      //console.log("i: ",i);
      // get uri url from contract
      const uri = await contract.tokenURI(i.tokenId)
    //  console.log("uri: ",uri);
      // use uri to fetch the nft metadata stored on ipfs
      const response = await fetch(uri + ".json")
    //  console.log("response: ",response);
      const metadata = await response.json()
      //console.log("metadata: ",metadata);
    //  const identicon = `data:image/png;base64,${new Identicon(metadata.name + priceAll, 330).toString()}`
    //  console.log("identicon: ",identicon);
      // define item object
      let item = {
        price: i.tokenPrice,
        itemId: i.tokenId,
        name: metadata.name,
        audio: metadata.audioMp3,
        image: metadata.image
      }

      return item
    }))
    setMarketItems(marketItems)
    setLoading(false)
  }
  const buyMarketItem = async (item) => {

    console.log("item: ->>>> ",item.price.toString())
    if(whitelisted){await (await contract.buyToken(item.itemId)).wait()}
    else {await (await contract.buyToken(item.itemId, { value: item.price.toString()})).wait()}
    loadMarketplaceItems()
  }
  const skipSong = (forwards) => {
    if (forwards) {
      setCurrentItemIndex(() => {
        let index = currentItemIndex
        index++
        if (index > marketItems.length - 1) {
          index = 0;
        }
        return index
      })
    } else {
      setCurrentItemIndex(() => {
        let index = currentItemIndex
        index--
        if (index < 0) {
          index = marketItems.length - 1;
        }
        return index
      })
    }
  }
  useEffect(() => {
    if (isPlaying) {
      audioRef.current.play()
    } else if (isPlaying !== null) {
      audioRef.current.pause()
    }
  })
  useEffect(() => {
    !marketItems && loadMarketplaceItems()
  })

  if (loading) return (
    <main style={{ padding: "18rem 0" }}>
      <h2 style={{ color:`white`}}>Loading...</h2>
    </main>
  )
  return (

    <div className="container-fluid mt-2"  style={{ padding: "1rem 1rem 5rem 1rem" }}>

      {marketItems.length > 0 ?
        <div className="row">
          <main role="main" className="col-lg-24 mx-auto" style={{ maxWidth: '360px' }}>
            <div className="content mx-auto">
              <audio src={marketItems[currentItemIndex].audio} ref={audioRef}></audio>
              <Card>
                <Card.Header><b>{marketItems[currentItemIndex].name}</b>, of <b>{marketItems.length}</b> NFT</Card.Header>
                <Card.Img variant="top" src={marketItems[currentItemIndex].image} />
                <Card.Body color="secondary">

                  <div className="d-grid px-4">
                  <Button size="sm" variant="primary" onClick={() => setIsPlaying(!isPlaying)}>
                    {isPlaying ? (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-pause" viewBox="0 0 16 16">
                        <path d="M6 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5z" />
                      </svg>
                    ) : (
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-play" viewBox="0 0 16 16">
                        <path d="M10.804 8 5 4.633v6.734L10.804 8zm.792-.696a.802.802 0 0 1 0 1.392l-6.363 3.692C4.713 12.69 4 12.345 4 11.692V4.308c0-.653.713-.998 1.233-.696l6.363 3.692z" />
                      </svg>
                    )}
                  </Button>
                    <ButtonGroup size="sm" aria-label="Basic example">
                      <Button variant="secondary" onClick={() => skipSong(false)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-skip-backward" viewBox="0 0 16 16">
                          <path d="M.5 3.5A.5.5 0 0 1 1 4v3.248l6.267-3.636c.52-.302 1.233.043 1.233.696v2.94l6.267-3.636c.52-.302 1.233.043 1.233.696v7.384c0 .653-.713.998-1.233.696L8.5 8.752v2.94c0 .653-.713.998-1.233.696L1 8.752V12a.5.5 0 0 1-1 0V4a.5.5 0 0 1 .5-.5zm7 1.133L1.696 8 7.5 11.367V4.633zm7.5 0L9.196 8 15 11.367V4.633z" />
                        </svg>
                      </Button>

                      <Button variant="secondary" onClick={() => skipSong(true)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-skip-forward" viewBox="0 0 16 16">
                          <path d="M15.5 3.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-1 0V8.752l-6.267 3.636c-.52.302-1.233-.043-1.233-.696v-2.94l-6.267 3.636C.713 12.69 0 12.345 0 11.692V4.308c0-.653.713-.998 1.233-.696L7.5 7.248v-2.94c0-.653.713-.998 1.233-.696L15 7.248V4a.5.5 0 0 1 .5-.5zM1 4.633v6.734L6.804 8 1 4.633zm7.5 0v6.734L14.304 8 8.5 4.633z" />
                        </svg>
                      </Button>
                    </ButtonGroup>
                  </div>
                </Card.Body>
                <Card.Footer>
                  <div className='d-grid my-1'>
                    <Button onClick={() => buyMarketItem(marketItems[currentItemIndex])} variant="primary" size="sm">
                      {`Buy NFT # ${marketItems[currentItemIndex].itemId} for ${ethers.utils.formatEther(marketItems[currentItemIndex].price)} MATIC`}
                    </Button>
                  </div>
                </Card.Footer>
              </Card>
            </div>
          </main >
        </div >
        : (
          <main style={{ padding: "10rem 0" }}>
            <h2>No listed assets</h2>
          </main>
        )}

    </div >
  );
}
export default Home
